<template>
  <div>
    <v-card>
      <v-card-title style="text-align:center !important; background-color: #1976d2 !important; color: #fafafa">
        Smile Please 🙂
      </v-card-title>
      <v-card-text style="padding: 0px;">
        <video id="camera" height="300" width="300" muted></video>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row style="margin: 0px">
          <v-col cols="6" md="6" sm6 style="padding: 5px; " >
            <v-btn  block @click="snap" style="background-color: #4caf50; color: #fafafa"
              >Snap</v-btn
            >
          </v-col>
          <v-col cols="6" md="6" sm6 style="padding: 5px; ">
            <v-btn block @click="cancel" style="background-color: #F44336; color: #fafafa"
              >Cancel</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { EventBus } from "./event-bus.js";
export default {
  data() {
    return {
      stream: null,
      video: null
    };
  },
  created() {
    const self = this;
    EventBus.$on("closeCamera", function() {
      console.log("Asking to close the camera");
      self.$emit("close");
    });
  },
  methods: {
    cancel() {
      this.$emit("close");
    },
    snap() {
      const { video } = this;
      const canvas = document.createElement("canvas");
      const scale = 1;

      /* if (device.platform.toLowerCase() == 'android' && parseInt( device.version, 10 ) <= 6){
        canvas.width  = 1024
        canvas.height = 1024
      }else { */
      canvas.width = video.videoWidth * scale > 2048 ? 2048 : video.videoWidth * scale;
      canvas.height = video.videoHeight * scale > 2048 ? 2048 : video.videoHeight * scale;
      console.log("Dimensions of the canvas " + canvas.width + " " + canvas.height);

      //}
      canvas.getContext("2d").drawImage(video, 0, 0, canvas.height, canvas.width);

      const base64 = canvas.toDataURL("image/png", 0.7);

      console.log("Length of the base64 " + base64.length);

      //Convert base64 to blob
      //var fileUrl = "data:" + mimeType + ";base64," + bytesBase64;
      /*
      fetch(base64)
          .then(response => response.blob())
          .then(blob => {
              var link = window.document.createElement("a");
              link.href = window.URL.createObjectURL(blob, { type: mimeType });
              link.download = fileName;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }); 
        */

      this.$parent.$emit("snap", base64);
      this.$emit("close");
    }
  },

  beforeDestroy() {
    console.log("Destrying video");

    const localMediaStream = this.stream;

    if (localMediaStream.stop) {
      localMediaStream.stop();
    } else {
      localMediaStream.getTracks().forEach(track => {
        track.stop();
      });
    }

    const videoElement = this.video;
    videoElement.pause();
    videoElement.removeAttribute("src"); // empty source
    videoElement.load();
    videoElement.parentNode.removeChild(videoElement);
  },

  async mounted() {
    const self = this;

    async function init() {
      try {
        const constraints = {
          audio: false,
          video: {
            width: 300,
            height: 300
          }
        };
        self.stream = await navigator.mediaDevices.getUserMedia(constraints);
        handleSuccess(self.stream);
      } catch (e) {
        console.log(e.toString());
        alert("Error occured while capturing image, kindly check permissions and web cam drivers");
      }
    }

    // Success
    function handleSuccess(stream) {
      const video = document.getElementById("camera");
      self.video = video;
      window.stream = stream;
      video.srcObject = stream;
      video.play();
    }
    init();
  }
};
</script>

<style scoped>
* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
}
</style>
